import { useChain } from './useChain';

import { fallbackOfferReturnStrategy } from '../../dataAccessLayer/chain/constants';
import { OfferReturnStrategy } from '../../dataAccessLayer/chain/types';

export const useOfferReturnStrategy = (): OfferReturnStrategy => {
  const chain = useChain();
  return chain?.configuration?.offerReturnStrategy || fallbackOfferReturnStrategy;
};

export const useOfferReturnDefaultStrategy = (): boolean => {
  const chain = useChain();
  return !!chain?.configuration?.offerReturnDefaultStrategy;
};
